<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="materialKeyword"
              @text="KeyWord = $event"
              :label="
                settings &&
                (settings.material_name_display_type == 2 ||
                  settings.material_name_display_type == 3)
                  ? $t('Material.materialNameAndCodeKeyword')
                  : $t('Material.materialNameKeyword')
              "
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategory v-model="categorySelected" />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Material.Fields.public_flg") }}
            </div>
            <v-chip-group v-model="publicFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("Material.publicFlgs.on") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("Material.publicFlgs.off") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
        <!-- <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("OverSellSetting.Fields.usable") }}
            </div>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
              >
                {{ $t("CRUD.choosed") }}
              </v-chip>
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
              >
                {{ $t("CRUD.unchoose") }}
              </v-chip>
            </v-chip-group>
          </v-row>
        </v-col> -->
      </v-row>
      <v-data-table
        :headers="headers"
        :items="materialItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:header.choose>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              materials.find((detail) => detail.choose != chooseAll)
                ? true
                : false
            "
            v-model="chooseAll"
            :true-value="1"
            :false-value="0"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("CRUD.chooseAll") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.material_name="{ item }">
          {{ item.material_name }}
          <br />
          <span class="caption secondary--text">
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </span>
        </template>
        <template v-slot:item.public_flg="{ item }">
          <v-chip
            small
            label
            :color="item.public_flg ? 'primary' : 'grey'"
            text-color="white"
          >
            {{
              item.public_flg
                ? $t("Material.publicFlgs.on")
                : $t("Material.publicFlgs.off")
            }}
          </v-chip>
        </template>
        <template v-slot:item.choose="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.choose"
              :true-value="1"
              :false-value="0"
              :disabled="item.disabled"
            >
              <template v-slot:label>
                <span class="caption ms-n2">
                  {{ $t(item.choose ? "CRUD.choosed" : "CRUD.unchoose") }}
                </span>
              </template>
            </v-checkbox>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption">
          {{
            $t("CRUD.chooseCount", [
              changed.length,
              changedDetails.length - changed.length,
            ])
          }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              changedDetails.filter((c) => c.new)
            );
            dialog = false;
          "
        >
          {{ $t("CRUD.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import OverSellSettings from "@/api/over_sell_settings";

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    fetchOptions: Object,
    type: Number,
    changed: Array,
    materialIds: Array,
    disabledChoosed: Boolean,
  },

  components: {
    SearcherKeyword,
    SearcherMaterialCategory,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_category.name",
        },
        {
          text: i18n.t("Material.Fields.material_code"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_code",
        },
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_name",
        },
        {
          text: i18n.t("Material.Fields.public_flg"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "public_flg",
        },
        {
          text: i18n.t("CRUD.chooseAll"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "choose",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    materialItems() {
      //前端搜索
      return this.materials.filter(
        (item) =>
          ((this.publicFlgs.length &&
            this.publicFlgs.find((flg) => flg == item.public_flg) !=
              undefined) ||
            !this.publicFlgs.length) &&
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          ((this.categorySelected &&
            item.material_category.code.indexOf(this.categorySelected.code) >
              -1) ||
            !this.categorySelected) &&
          ((this.materialKeyword &&
            item.Description.indexOf(this.materialKeyword) > -1) ||
            !this.materialKeyword)
      );
    },
    choosenCount() {
      return this.changedDetails.filter((d) => d.valid == 1).length;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    materialKeyword: "",
    categorySelected: null,
    chooseFlgs: [0],
    publicFlgs: [1],
    itemsPerPageOptions: 10,
    chooseAll: 0,
    fetchTimestamp: 0, //第一次获取商品列表的时间
    changedDetails: [],
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.materialKeyword = this.KeyWord;
    },
    //获取material列表
    getMaterialsFromAPI() {
      // if (
      //   new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000 &&
      //   !refresh
      // ) {
      //   this.materials = this.materials.map((material) => {
      //     material.Description = i18n.t(
      //       this.settings
      //         ? this.settings.material_name_display_type == 3
      //           ? "Material.materialNameWithCodeAndStandard"
      //           : this.settings.material_name_display_type == 2
      //           ? "Material.materialNameWithCode"
      //           : "Material.materialName"
      //         : "Material.materialName",
      //       [
      //         material.material_code,
      //         material.material_name,
      //         material.standard_name,
      //       ]
      //     );

      //     //默认勾选
      //     var detail = this.changedDetails.find(
      //       (s) => material.id == s.material_id
      //     );
      //     if (detail) {
      //       material = Object.assign({}, material, {
      //         choose: 1,
      //         disabled: true,
      //       });
      //     } else {
      //       material = Object.assign({}, material, {
      //         choose: 0,
      //         disabled: false,
      //       });
      //     }

      //     return material;
      //   });

      //   return;
      // }

      var options = Object.assign(
        {},
        {
          mode: this.fetchOptions.mode,
          stock_id: this.fetchOptions.stock_id,
          type: this.type,
        }
      );
      OverSellSettings.fetchSelectMaterials(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials.map((material) => {
              material.Description = i18n.t(
                this.settings
                  ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                [
                  material.material_code,
                  material.material_name,
                  material.standard_name,
                ]
              );
              //默认勾选
              var detail = this.changedDetails.find(
                (s) => material.id == s.material_id
              );
              if (detail) {
                material = Object.assign({}, material, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                material = Object.assign({}, material, {
                  choose: 0,
                  disabled: false,
                });
              }

              return material;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          // 每次打开对话框重置查询条件和changedDetails
          this.materialKeyword = "";
          if (this.changed)
            this.changedDetails = JSON.parse(JSON.stringify(this.changed));

          this.getMaterialsFromAPI();
        }
      },
    },
    fetchOptions: {
      immediate: true,
      deep: true,
      handler() {
        if (this.fetchOptions.stock_id) this.getMaterialsFromAPI();
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.materialKeyword = "";
          this.categorySelected = null;
          this.chooseFlgs = [0];
          this.publicFlgs = [1];
          this.changedDetails = [];
          this.chooseAll = 0;
        }
      },
    },
    chooseAll: {
      handler() {
        this.materials = this.materials.map(
          function (detail) {
            var d = this.materialItems.find((d) => d.id == detail.id);
            if (d) detail.choose = this.chooseAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    materials: {
      deep: true,
      handler() {
        this.materials.forEach((m) => {
          if (m.choose == 1) {
            var detail = this.changedDetails.find((s) => m.id == s.material_id);
            if (!detail) {
              var material = {
                new: this.changedDetails.length + 1,
                material_id: m.id,
                material_code: m.material_code,
                material_name: m.material_name,
                category_code: m.material_category
                  ? m.material_category.number
                  : "",
                category_name: m.material_category
                  ? m.material_category.name
                  : "",
                standard_name: m.standard_name,
                current_count: m.current_count,
                available_num: 0,
                unit: m.default_unit,
              };
              this.changedDetails.push(material);
            }
          } else {
            if (
              this.changedDetails.findIndex(
                (d) => d.material_id == m.id && d.new
              ) > -1
            ) {
              this.changedDetails.splice(
                this.changedDetails.findIndex(
                  (d) => d.material_id == m.id && d.new && !d.disabled
                ),
                1
              );
            }
          }
        }); // 新改变的，添加到changedDetails数组中
      },
    },
  },
};
</script>